module.exports = {"c2c":{"title":"Podemos ajudar?","shortTitle":"Ajuda","tagLine":"Ligamos grátis"},"fis":"Resumo Contratual"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/pt/header.json
// module id = kSQE
// module chunks = 64